module.exports = __webpack_public_path__ + "static/media/800hz.d2dd31cf.mp3";